import React, { useState, useEffect } from "react";

// components
import { ListWrap } from "src/components";

// api
// import { getEventByCategory } from "../api";
import {
  clearCacheCategory,
  getEventByCategoryCache,
} from "../../utils/cacheApi";

// mockup
import mockup from "src/utils/data";

// utils
import { getNextCategories } from "src/utils/helpers";

const NextCategories = ({
  currCategory,
  categories,
  user,
  userLocation,
  handleClick,
}) => {
  const [listOne, setListOne] = useState({
    category: {},
    list: mockup.empty_3,
  });
  const [listTwo, setListTwo] = useState({
    category: {},
    list: mockup.empty_3,
  });
  const [listThree, setListThree] = useState({
    category: {},
    list: mockup.empty_3,
  });

  useEffect(() => {
    if (currCategory) {
      let nextCatg = getNextCategories(currCategory, mockup.by_category);
      // setListOne({ ...listOne, category: nextCatg[0] });
      // setListTwo({ ...listTwo, category: nextCatg[1] });
      // setListThree({ ...listThree, category: nextCatg[2] });

      fetchEvent(nextCatg[0], setListOne);
      fetchEvent(nextCatg[1], setListTwo);
      fetchEvent(nextCatg[2], setListThree);
    }
  }, [currCategory, user, userLocation, categories]);

  const fetchEvent = (_catg, _callback) => {
    _callback({ category: _catg, list: mockup.empty_3 });

    let params = {
      catgId: _catg.data.Categoryid,
      lat: userLocation?.lat,
      lng: userLocation?.lng,
    };

    if (user) {
      params = {
        ...params,
        userId: user.userId,
        accessToken: user.accessToken,
        lat: user?.location?.lat,
        lng: user?.location?.lng,
      };
    }

    getEventByCategoryCache(params)
      .then((res) => {
        if (res.data.Status) {
          _callback({
            category: _catg,
            list: res.data.Results,
          });
        } else {
          console.log({ _catg, res: res.data.ErrorMessage });
          const id = `/Event${params.catgId}`;
          clearCacheCategory(id);
          _callback({
            category: _catg,
            list: null,
          });
        }
      })
      .catch((err) => {
        console.log({ _catg, err });
        _callback({
          category: _catg,
          list: null,
        });
      });
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      <ListWrap
        heading={listOne.category?.data?.CategoryName || ""}
        items={listOne.list}
        to
        limit
        handleClick={() => handleClick(listOne.category?.data)}
      />
      <ListWrap
        heading={listTwo.category?.data?.CategoryName || ""}
        items={listTwo.list}
        to
        limit
        handleClick={() => handleClick(listTwo.category?.data)}
      />
      <ListWrap
        heading={listThree.category?.data?.CategoryName || ""}
        items={listThree.list}
        to
        limit
        handleClick={() => handleClick(listThree.category?.data)}
      />
    </div>
  );
};

export default NextCategories;
